import { runDemo } from "../shared/demoRunner";
import { createDragDropTestScene } from "./scene";

runDemo({ createScene: createDragDropTestScene });
